<template>
  <div
    class="style1-wap"
    :class="{
      must: fieldObj.required == 1,
      err: fieldObj.dirty && fieldObj.invalid,
      statusNoBorder: fieldStyle == 'style2-wap'
    }"
  >
    <div class="u-label">
      {{ fieldObj.displayName }}
    </div>
    <div class="m-checkbox-list-wap">
      <div
        v-for="(o, i) in fieldObj.listOptions"
        :key="o.optionId"
        class="m-checkbox-wrapper"
      >
        <a-checkbox
          class="m-checkbox-item"
          :class="{
            'has-desc':
              fieldObj.options &&
              fieldObj.options[i] &&
              (fieldObj.options[i].optionDescText ||
                fieldObj.options[i].optionDescHrefText)
          }"
          @change="handleChange"
          :value="o.optionId"
          :disabled="fieldObj.disabled || o.disabled"
          v-model="o.checked"
        >
          {{ o.optionValue }}
          <div
            v-if="
              fieldObj.options &&
                fieldObj.options[i] &&
                fieldObj.options[i].optionDescText
            "
            class="u-desc"
          >
            {{ fieldObj.options[i].optionDescText }}
          </div>
          <div
            v-if="
              fieldObj.options &&
                fieldObj.options[i] &&
                fieldObj.options[i].optionDescHrefText
            "
            class="u-desc"
          >
            <a :href="fieldObj.options[i].optionDescHref">{{
              fieldObj.options[i].optionDescHrefText
            }}</a>
          </div>
        </a-checkbox>
        <input
          class="otherInput"
          v-if="o.otherisFillIn == 1 && o.checked"
          type="text"
          v-model="o.otherValue"
          placeholder="请输入"
          @blur="inputBlur($event, o)"
        />
        <div
          class="u-reg-err-tips"
          v-if="
            o.checked &&
              o.otherisFillIn == 1 &&
              o.otherIsRequire == 1 &&
              !o.otherValue
          "
        >
          请填写
        </div>
      </div>
    </div>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
</template>

<script>
import checkboxMixin from "../../field/new-fields/checkbox";
export default {
  name: "sk-checkbox-wap",
  mixins: [checkboxMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
  text-align: left;
  padding: 20px;
}
.m-checkbox-wrapper {
  display: block;
  margin-bottom: 8px;
}
.otherInput {
  display: block;
  width: calc(100% - 24px);
  margin-top: 4px;
  margin-left: 24px;
  box-sizing: border-box;
}
.otherInput::placeholder {
  color: #d9d9d9;
}
.otherInput:disabled {
  cursor: not-allowed;
  background-color: #fff;
}
.u-reg-err-tips {
  padding-left: 24px;
}
.m-checkbox-item {
  display: flex;
  align-items: flex-start;
}
::v-deep .ant-checkbox-wrapper .ant-checkbox {
  top: 0.1em;
}
</style>
